import React, { Component }       from 'react';
import { Modal, Button }          from 'react-bootstrap';

export class MediaModal extends Component {

  render() {
    return (
        <Modal size="lg" show={this.props.show} onHide={() => this.props.toggleMediaModal(false)}>
            <Modal.Body>
              <img className="w-100" src={this.props.media} alt="modal-media-message"/>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={() => this.props.toggleMediaModal(false)}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>
    )
  }
}